import getCalendarOwnerFromItem from './getCalendarOwnerFromItem';
import {
    Calendar,
    getAllCalendars,
    isCalendarInMailbox,
    isWritableCalendar,
    isTeamsCalendarEntry,
} from 'owa-calendar-cache';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Returns the list of writable calendars
 */
export default function getWritableCalendarsForUser(
    event: CalendarEvent,
    userIdentity: string
): Calendar[] {
    const mailboxOwner = event.ItemId ? getCalendarOwnerFromItem(event).EmailAddress : null;

    return getAllCalendars().filter(
        calendar =>
            isWritableCalendar(calendar) &&
            !isTeamsCalendarEntry(calendar) &&
            (!mailboxOwner || isCalendarInMailbox(calendar, mailboxOwner)) &&
            calendar.id.mailboxInfo.userIdentity === userIdentity
    );
}
